import { render, staticRenderFns } from "./CompanyData.vue?vue&type=template&id=0202474e&scoped=true&"
import script from "./CompanyData.vue?vue&type=script&lang=js&"
export * from "./CompanyData.vue?vue&type=script&lang=js&"
import style0 from "./CompanyData.vue?vue&type=style&index=0&id=0202474e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0202474e",
  null
  
)

export default component.exports